import React from "react";
import { ConversationsBubbleType } from "../../../../libraries/types_interface/chats/ChatsTypes";
import GoogleMapWidget from "../../../../widget/common/ui/GoogleMapWidget";
import { TextBlock } from "../../../../widget/common/ui/Text";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";

const BubbleLocation: React.FC<ConversationsBubbleType> = ({
  message,
  longPressStatus = false,
}) => {
  const title: string = message.split("|")[0];
  const lat: number = Number(message.split("|")[1]);
  const long: number = Number(message.split("|")[2]);

  const width: number = 250;

  const handleClick = () => {
    if (!longPressStatus) {
      UtilityHelper.naviagteGoogleMap(lat.toString(), long.toString());
    }
  };
  return (
    <div className="bubble-location">
      <div style={{ width: width }} role="button" onClick={handleClick}>
        {<GoogleMapWidget lat={lat} lng={long} width={width} />}
        <TextBlock
          fontSize="15_16"
          fontName="book"
          textColor="black"
          className="pt-2"
          maxLine={2}
        >
          {title}
        </TextBlock>
      </div>
    </div>
  );
};

export default BubbleLocation;
